import React from 'react';
import { motion } from 'framer-motion';
import { Wallet } from 'lucide-react';

interface WalletBoxProps {
  balance: number;
  earned: number;
}

export const WalletBox: React.FC<WalletBoxProps> = ({ balance, earned }) => {
  return (
    <motion.div 
      className="glass p-4 min-w-[400px] relative overflow-hidden"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
    >
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-neon-green/5" />
      <div className="absolute inset-0 backdrop-blur-[2px]" />

      {/* Content */}
      <div className="relative flex items-center space-x-4">
        <div className="p-3 rounded-lg bg-black/30 border border-neon-green/20">
          <Wallet className="w-6 h-6 text-neon-green" />
        </div>
        <div className="flex-1 grid grid-cols-2 gap-6">
          <div>
            <div className="text-sm text-gray-400 mb-1">Balance</div>
            <div className="text-2xl font-bold text-neon-green">
              ${balance.toLocaleString()}
            </div>
          </div>
          <div>
            <div className="text-sm text-gray-400 mb-1">Earned Today</div>
            <div className="text-2xl font-bold text-neon-purple">
              +${earned.toLocaleString()}
            </div>
          </div>
        </div>
      </div>

      {/* Glow Effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-neon-green/20 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-neon-green/10 to-transparent" />
        <div className="absolute inset-y-0 left-0 w-px bg-gradient-to-b from-transparent via-neon-green/20 to-transparent" />
        <div className="absolute inset-y-0 right-0 w-px bg-gradient-to-b from-transparent via-neon-green/10 to-transparent" />
      </div>

      {/* Scan line effect */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-green/10 to-transparent"
        animate={{
          y: ['-100%', '100%'],
        }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear',
        }}
        style={{ height: '2px' }}
      />
    </motion.div>
  );
};